import { useMemo } from 'react';
import { goBack, navigate, resetNav, resetStack } from '../../app/navigation';
import { useT } from '../../i18n/i18n';
import { useStore } from '../../state/createStore';
import { evidenceStore } from '../../state/evidenceStore';
import { findingStore } from '../../state/findingStore';
import { inspectionStore } from '../../state/inspectionStore';
import { buildPhotoPool, poolCounts } from '../../state/photoPool';
import { Button, Card, ChoiceCard, EmptyState, SectionHeader, TopBar } from '../../ui/components';
import { PoolAiCard } from './PoolAiCard';

// After the pool is filled (task book §8): the processing choice.
//   AI 分析全部照片 (Owner device test 2026-10-05: 「导入完成没有明显的AI分析全部照片的按钮…这里需要增加AI分析照片池
//   内容的选项」) — the AI sorts the pool's photos into the areas and rows and analyzes area by area; the
//   inspector reviews and edits every area (src/state/poolAiStore.ts);
//   不用 AI — the inspector walks the checklist and picks photos per item from the pool.
// Before 2026-10-05 the whole-pool lane did not exist and this screen only offered the manual walk.
export function ImportChoiceScreen(props: { inspectionId: string }) {
  const { t, tp } = useT();
  const inspection = useStore(inspectionStore, (s) => s.inspections.find((i) => i.id === props.inspectionId) ?? null);
  const inspectionState = useStore(inspectionStore, (s) => s);
  const evidenceState = useStore(evidenceStore, (s) => s);
  const findingState = useStore(findingStore, (s) => s);
  const counts = useMemo(() => poolCounts(buildPhotoPool(props.inspectionId, evidenceState, inspectionState, findingState)), [props.inspectionId, evidenceState, inspectionState, findingState]);

  if (!inspection) {
    return (
      <div className="screen">
        <TopBar title={t('import.choiceTitle')} onBack={() => resetNav({ screen: 'inspectionList' })} />
        <EmptyState title={t('inspection.notFoundTitle')} body={t('inspection.notFoundBody')} />
      </div>
    );
  }

  function startManual() {
    resetStack([{ screen: 'inspectionList' }, { screen: 'inspection', inspectionId: props.inspectionId }]);
  }

  return (
    <div className="screen" data-testid="import-choice-screen">
      <TopBar title={t('import.choiceTitle')} subtitle={tp('import.inPool', counts.all)} onBack={goBack} />
      <div className="screen-body">
        <Card tone="low" testId="import-choice-intro">
          <SectionHeader eyebrow={t('import.eyebrow')} title={t('import.choiceHeading')} />
          <p className="card-body">{t('import.choiceBody')}</p>
        </Card>
        <div className="choice-stack choice-stack-page">
          <PoolAiCard inspection={inspection} onAddNotes={() => navigate({ screen: 'photoPool', inspectionId: props.inspectionId, focus: { kind: 'unclassified' } })} testId="choice-ai" />
          <ChoiceCard icon="rule" title={t('import.manualTitle')} body={t('import.manualBody')} onClick={startManual} testId="choice-manual" />
        </div>
        <div className="screen-actions">
          <Button variant="secondary" icon="perm_media" onClick={() => navigate({ screen: 'photoPool', inspectionId: props.inspectionId })} testId="choice-open-pool">
            {t('pool.open')}
          </Button>
          <p className="card-note overview-count-note">{t('import.aiRules')}</p>
        </div>
      </div>
    </div>
  );
}
